// src/store/useAppConfigStore.js
import { create } from "zustand";

const useAppConfigStore = create((set) => ({
  firstDayOfWeek: "monday",
  dateFormat: "DD MM YYYY",
  dateSeparator: "-",
  currencyFormat: "1,234,567.89",
  decimalPlaces: 2,
  country: "",
  timezone: null,
  language: null,

  setAppConfig: (config) => {
    const newState = {
      firstDayOfWeek: config.first_day_of_the_week || "monday",
      dateFormat: config.date_format || "DD MM YYYY",
      dateSeparator: config.date_separator || "-",
      currencyFormat: config.currency_format || "1,234,567.89",
      decimalPlaces: config.decimal_places ?? 2,
      country: config.country || "",
      timezone: config.timezone || null,
      language: config.language || null,
    };
    set(newState);
  },

  resetAppConfig: () =>
    set({
      firstDayOfWeek: "monday",
      dateFormat: "DD MM YYYY",
      dateSeparator: "-",
      currencyFormat: "1,234,567.89",
      decimalPlaces: 2,
      country: "",
      timezone: null,
      language: null,
    }),
}));

export default useAppConfigStore;
